import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";

import LoginScreen from "./components/LoginScreen";
import UploadScreen from "./components/UploadScreen";
import OptionsScreen from "./components/OptionsScreen";
import ShareScreen from "./components/ShareScreen";
import BuyScreen from "./components/BuyScreen";

function App() {
  return (
    <AppProvider>
      <Router>
        <div className="app-container">
          <header>
            <h1>cNFT App</h1>
          </header>
          <Routes>
            <Route path="/" element={<LoginScreen />} />
            <Route path="/upload" element={<UploadScreen />} />
            <Route path="/options" element={<OptionsScreen />} />
            <Route path="/share" element={<ShareScreen />} />
            <Route path="/:chain/:collection/:tokenId" element={<BuyScreen />} />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
